import { useQuery, UseQueryOptions } from 'react-query';
import { createProductsEndpoint } from '@/src/constants/endpoints';
import { ProductsResponse } from '@/src/types/Response';
import { apiService } from '@/src/services/api-service';

export const useProductsQuery = (
  accountId: string | null | undefined,
  options?: UseQueryOptions<ProductsResponse>,
) =>
  useQuery({
    queryKey: `orion-products-${accountId}`,
    queryFn: () =>
      apiService.get<ProductsResponse>({
        url: createProductsEndpoint(accountId ?? ''),
      }),
    retryOnMount: false,
    ...options,
    enabled: !!accountId && (options?.enabled ?? true),
  });
